import mixpanel from "mixpanel-browser";

import {
  SOAP_FIELDS,
  CUSTOM_FIELDS,
  TEMPLATE_FIELDS,
  TEMPLATE_TYPES,
} from "./constants";
import {
  cleanExtractedData,
  processCustomFields,
  processSoapFields,
} from "./TemplateBuilder/utils";

export const createNewTemplate = async (
  templateType,
  isFavourite = true,
  createAutoTemplate,
) => {
  const createTemplateInput = { templateType, isFavourite };

  if (templateType === TEMPLATE_TYPES.SOAP) {
    createTemplateInput.templateFields = SOAP_FIELDS;
  } else if (templateType === TEMPLATE_TYPES.CUSTOM) {
    createTemplateInput.templateFields = CUSTOM_FIELDS;
  }
  try {
    const response = await createAutoTemplate({
      variables: { createTemplateInput },
    });
    mixpanel.track("Create template button clicked", {
      templateType,
      templateUuid: response?.data?.createAutoTemplate?.templateUuid,
    });
    return response?.data?.createAutoTemplate?.templateUuid;
  } catch (error) {
    alert("error", "Error creating template. Please try again.");
    mixpanel.track("Template creation error", {
      error: error.message,
    });
  }
};

/**
 * Assembles dropdown options with section headers for the template preset dropdown.
 * Used by both the classic builder's TemplateExamplesChipMenu and the wizard's StartingPointStep.
 */
export function buildTemplateDropdownOptions({
  defaultOptions = [],
  libraryOptions = [],
  myTemplateOptions = [],
  sharedTemplateOptions = [],
}) {
  const options = [];

  if (defaultOptions.length > 0) {
    options.push({
      isHeader: true,
      label: "Scribenote Defaults",
      value: "scribenote-defaults-header",
    });
    options.push(...defaultOptions);
  }

  if (libraryOptions.length > 0) {
    options.push({
      isHeader: true,
      label: "Template Library",
      value: "template-library-header",
    });
    options.push(...libraryOptions);
  }

  if (myTemplateOptions.length > 0) {
    options.push({
      isHeader: true,
      label: "My Templates",
      value: "my-templates-header",
    });
    options.push(...myTemplateOptions);
  }

  if (sharedTemplateOptions.length > 0) {
    options.push({
      isHeader: true,
      label: "Shared with me",
      value: "shared-templates-header",
    });
    options.push(...sharedTemplateOptions);
  }

  return options;
}

/**
 * Applies a built-in (non-user) preset template to the form.
 * Handles cleanExtractedData, field processing, and setValue calls.
 */
export function applyBuiltInPreset(setValue, preset, templateType) {
  const cleanedContent = cleanExtractedData(preset);
  if (templateType === TEMPLATE_TYPES.CUSTOM) {
    setValue(
      "templateFields",
      processCustomFields(cleanedContent[TEMPLATE_FIELDS.CUSTOM]),
      { shouldDirty: true },
    );
  } else {
    setValue("templateFields", processSoapFields(cleanedContent), {
      shouldDirty: true,
    });
  }
  setValue("userPreferences", preset.preferences || "");
  if (preset.sampleTranscript) {
    setValue("sampleTranscript", preset.sampleTranscript);
  }
}

/**
 * Resets the form to blank fields for a given template type.
 */
export function resetTemplateFields(setValue, templateType) {
  setValue("templateType", templateType);
  setValue(
    "templateFields",
    templateType === TEMPLATE_TYPES.SOAP
      ? SOAP_FIELDS
      : CUSTOM_FIELDS,
  );
  setValue("userPreferences", "");
}
